import { useCallback } from 'react';
import { QueryStatus } from 'react-query';
import {
  useExportAudio,
  useExportVideo,
  useIsAudioProject,
  useProjectCuid,
  useProjectName,
} from '../state';

export interface UseDownloadClipResult {
  status: QueryStatus;
  downloadClip: (startWordId: number, endWordId: number) => void;
}

export default function useDownloadClip(): UseDownloadClipResult {
  const { status: audioStatus, exportAudio } = useExportAudio();
  const { status: videoStatus, exportVideo } = useExportVideo();
  const { data: isAudioProject } = useIsAudioProject();
  const { data: projectName } = useProjectName();
  const { data: projectCuid } = useProjectCuid();

  const downloadClip = useCallback(
    (startWordId: number, endWordId: number): void => {
      if (!projectCuid || !projectName) {
        return;
      }

      (isAudioProject ? exportAudio : exportVideo)({
        projectCuid,
        projectName,
        download: true,
        selection: {
          startWordId,
          endWordId,
        },
      });
    },
    [exportAudio, exportVideo, isAudioProject, projectCuid, projectName],
  );

  return {
    status: isAudioProject ? audioStatus : videoStatus,
    downloadClip,
  };
}
